module.exports = __webpack_public_path__ + "img/japan-diabetes-mellitus-male.f499091b.png";